<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.pi_inoutno }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div
            class="weui-form-preview__item"
            v-if="form.main.pi_date"
            slot="pi_date"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pi_date || "单据日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.pi_date
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.pi_vendname"
            slot="pi_vendname"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pi_vendname || "供应商名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pi_vendname
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.pi_custname"
            slot="pi_custname"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pi_custname || "客户名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pi_custname
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.pi_address"
            slot="pi_address"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pi_address || "送货地址"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pi_address
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pi_seller"
            v-if="form.main.pi_seller"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pi_seller || "业务员"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pi_seller
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pi_buyername"
            v-if="form.main.pi_buyername"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pi_buyername || "借货人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pi_buyername
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.pi_departmentname"
            slot="pi_departmentname"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pi_departmentname || "部门"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pi_departmentname
            }}</span>
          </div>

          <custom-field
            :readOnly="true"
            :label="customLabel.pi_text1 || '自定义字段1'"
            v-model="form.main.pi_text1"
            slot="pi_text1"
            hidden="true"
          />
          <custom-field
            :readOnly="true"
            :label="customLabel.pi_text2 || '自定义字段2'"
            v-model="form.main.pi_text2"
            slot="pi_text2"
            hidden="true"
          />
          <custom-field
            :readOnly="true"
            :label="customLabel.pi_text3 || '自定义字段3'"
            v-model="form.main.pi_text3"
            slot="pi_text3"
            hidden="true"
          />
          <custom-field
            :readOnly="true"
            :label="customLabel.pi_text4 || '自定义字段4'"
            v-model="form.main.pi_text4"
            slot="pi_text4"
            hidden="true"
          />
          <custom-field
            :readOnly="true"
            :label="customLabel.pi_text5 || '自定义字段5'"
            v-model="form.main.pi_text5"
            slot="pi_text5"
            hidden="true"
          />
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.pd_pdno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="pd_prodcode">
              <label class="weui-form-preview__label">{{
                customLabel.pd_prodcode || "物料编号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pd_prodcode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_detail">
              <label class="weui-form-preview__label">{{
                customLabel.pr_detail || "物料名称"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_detail
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="pr_orispeccode"
              v-if="item.productDTO.pr_orispeccode"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pr_orispeccode || "型号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_orispeccode
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="pr_spec"
              v-if="item.productDTO.pr_spec"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pr_spec || "规格"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.productDTO.pr_spec
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_whname">
              <label class="weui-form-preview__label">{{
                customLabel.pd_whname || "调出仓库"
              }}</label>
              <span class="weui-form-preview__value">{{ item.pd_whname }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_inwhname">
              <label class="weui-form-preview__label">{{
                customLabel.pd_inwhname || "调入仓库"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pd_inwhname
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_outqty">
              <label class="weui-form-preview__label">{{
                customLabel.pd_outqty || "数量"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.pd_outqty }} {{ item.productDTO.pr_unit }}</span
              >
            </div>
            <div
              class="weui-form-preview__item"
              slot="pd_batchcode"
              v-if="item.pd_batchcode"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pd_batchcode || "批次号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pd_batchcode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_price">
              <label class="weui-form-preview__label">{{
                customLabel.pd_price || "成本单价(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.pd_price, "#,##0.####")
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_total">
              <label class="weui-form-preview__label">{{
                customLabel.pd_total || "金额(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.pd_total, "#,##0.00")
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="pd_date"
              v-if="item.pd_date"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pd_date || "承诺归还日期"
              }}</label>
              <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{ item.pd_date }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="pd_backqty"
              v-if="item.pd_backqty"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pd_backqty || "已归还数量"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.pd_backqty
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              slot="pd_remark"
              v-if="item.pd_remark"
            >
              <label class="weui-form-preview__label">{{
                customLabel.pd_remark || "备注"
              }}</label>
              <span class="weui-form-preview__value">{{ item.pd_remark }}</span>
            </div>
            <custom-field
              :readOnly="true"
              :label="customLabel.pd_text1 || '自定义字段1'"
              v-model="item.pd_text1"
              slot="pd_text1"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.pd_text2 || '自定义字段2'"
              v-model="item.pd_text2"
              slot="pd_text2"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.pd_text3 || '自定义字段3'"
              v-model="item.pd_text3"
              slot="pd_text3"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.pd_text4 || '自定义字段4'"
              v-model="item.pd_text4"
              slot="pd_text4"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.pd_text5 || '自定义字段5'"
              v-model="item.pd_text5"
              slot="pd_text5"
              hidden="true"
            />
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{
              form.main.pi_remark
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">金额(元)</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.pi_costtotal
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/stock/goodslend_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="turn_goodsback"
        >转还货单</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="turn_salesorder"
        >转销售订单</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    CustomField,
  },
  data() {
    return {
      baseUrl: "/api/storage/prodinout",
      codeField: "pi_inoutno",
      statusField: "pi_statuscode",
      caller: "GoodsLend",
      xtype: "stock-goodslend-formpanel",
    };
  },
  methods: {
    turn_goodsback() {
      let me = this,
        code = me.form.main.pi_inoutno,
        items = me.form.items;
      let arr = [],
        jsonData = null;
      items.map((item) => {
        arr.push({
          id: item.id,
          code,
          qty: Number(item.pd_outqty) - Number(item.pd_backqty),
        });
      });

      jsonData = {
        baseDTOs: arr,
      };
      me.$loading({
        url: "/api/storage/prodinout/turnGoodsBack",
        method: "POST",
        jsonData,
      }).then(function (res) {
        if (res.success) {
          me.$weui.toast("还货成功", 2000);

          me.$router.push({
            name: "GoodsBackEdit",
            params: {
              id: res.data.list[0].id,
            },
          });
        } else {
          me.$weui.topTips("还货失败:"+ res.data.list[0].message, 2000);
        }
      });
    },
    turn_salesorder() {
      let me = this,
        code = me.form.main.pi_inoutno,
        cuid = me.form.main.pi_custid,
        items = me.form.items;
      let arr = [],
        jsonData = null;
      items.map((item) => {
        arr.push({
          id: item.id,
          code,
          qty: item.pd_outqty,
        });
      });

     
      jsonData = {
        cuid: cuid,
        baseDTOs: arr,
      };
     
      me.$loading({
        url: "/api/storage/prodinout/turnSale",
        method: "POST",
        jsonData,
      }).then(function (res) {
        if (res.success) {
          me.$weui.toast("转单成功", 2000);
          me.$router.push({
            name: "SaleOrderEdit",
            params: {
              id: res.data.list[0].id,
            },
          });
        } else {
          me.$weui.topTips("转单失败:"+ res.data.list[0].message, 2000); 
        }
      });
    },
  },
};
</script>